import "./Rates.module.css";
import Header from "@/reusable_sections/Header";
import PriceList from "./sections/PriceList";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function RatesPage() {
  return <div>
      <Header />
      <PriceList />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}